<template>
  <div class="container-fluid">
    <mdb-container>
      <mdb-row>
        <mdb-card-title>
          <strong> Add or Remove Asset States</strong>
        </mdb-card-title>
      </mdb-row>

      <mdb-row>
        <AssetStatesConfig />
      </mdb-row>
    </mdb-container>
  </div>
</template>

<script>
import AssetStatesConfig from "@/components/AssetStatesConfig";
import { mdbCardTitle, mdbRow, mdbContainer } from "mdbvue";

export default {
  name: "AssetStates",
  components: {
    AssetStatesConfig,
    mdbCardTitle,
    mdbRow,
    mdbContainer,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
